import {
  PRIVILEGE_ADMIN_BI,
  PRIVILEGE_ADMIN_BOM,
  PRIVILEGE_ADMIN_CALENDAR,
  PRIVILEGE_ADMIN_CAM,
  PRIVILEGE_ADMIN_CONTROL,
  PRIVILEGE_ADMIN_MACHINE,
  PRIVILEGE_ADMIN_MACHINE_GROUP,
  PRIVILEGE_ADMIN_OF,
  PRIVILEGE_ADMIN_PRESETTING,
  PRIVILEGE_ADMIN_REFRIGRETAION,
  PRIVILEGE_ADMIN_TOOL,
  PRIVILEGE_ADMIN_USERS,
  PRIVILEGE_APP_ASSISTANT,
  PRIVILEGE_APP_BI,
  PRIVILEGE_APP_CAM,
  PRIVILEGE_APP_CHECK_MACHINE,
  PRIVILEGE_APP_CHECK_OPERATOR,
  PRIVILEGE_APP_CHECK_TOOL,
  PRIVILEGE_APP_CNC,
  PRIVILEGE_APP_DASHBOARD,
  PRIVILEGE_APP_MAINTENANCE,
  PRIVILEGE_APP_MASTER_TASK,
  PRIVILEGE_APP_OF,
  PRIVILEGE_APP_PURCHASING,
  PRIVILEGE_APP_TECHNICAL_OFFICE,
  PRIVILEGE_APP_QUALITY,
  PRIVILEGE_APP_PRODUCTION,
  PRIVILEGE_APP_READINESS,
  PRIVILEGE_APP_SIMULATE,
  PRIVILEGE_APP_SIGNING_VALIDATION,
  PRIVILEGE_APP_STATUS,
  PRIVILEGE_APP_TASK,
  PRIVILEGE_APP_TM_HISTORICAL,
  PRIVILEGE_APP_TM_ORDER_REQUEST,
  PRIVILEGE_APP_TM_PENDING_ORDERS,
  PRIVILEGE_APP_TM_SEND_ERP,
  PRIVILEGE_APP_TM_TOOL,
  PRIVILEGE_APP_TM_VALIDATE_RECONSTRUCTION,
  PRIVILEGE_APP_VISUALIZATOR,
  PRIVILEGE_APP_WORKING_HOUR,
} from '../config/privileges.config';
import { PRIVILEGE_SA } from '../config/roles.config';
import { getSession } from '../services/storage.service';
import { find } from './collection.utils';

// tslint:disable-next-line: max-line-length
export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  const decoded = decodeURIComponent(escape(window.atob(base64)));

  return JSON.parse(decoded);
};

const getParsedToken = () => {
  const session = getSession();
  return (session) ? parseJwt(session.token) : null;
};

export const getUserLogged = () => {
  const decoded = getParsedToken() || {};
  return decoded.sub || null;
};

export const getFirstName = () => {
  const decoded = getParsedToken() || {};

  return decoded.firstName || null;
};

export const getLastName = () => {
  const decoded = getParsedToken() || {};

  return decoded.lastName || null;
};

export const getFullName = () => {
  const firstName = getFirstName() || '';
  const lastName = getLastName() || '';

  return `${firstName} ${lastName}`;
};

const getPrivileges = () => {
  const decoded = getParsedToken() || {};
  let privileges = [];

  if (decoded && decoded.privileges) {
    privileges = decoded.privileges.split(',');
  }
  return privileges;
};

export const hasAnyPrivileges = () => {
  const decoded = getParsedToken() || {};
  const privileges = getPrivileges();

  return decoded && privileges.length > 0;
};

const hasPrivilege = (privilegeToCheck: string) => {
  const privileges = getPrivileges();
  return !!find(privilege => privilege === privilegeToCheck, privileges);
};

export const isSAPrivilege = () => {
  return hasPrivilege(PRIVILEGE_SA);
};

export const isAppWorkingHourPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_WORKING_HOUR);
};

export const isAppDashboardPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_DASHBOARD);
};

export const isAppAssistantPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_ASSISTANT);
};

export const isAppBI = () => {
  return hasPrivilege(PRIVILEGE_APP_BI);
};

export const isAppStatusPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_STATUS);
};

export const isAppOFPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_OF);
};

export const isAppCAMPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_CAM);
};

export const isAppTaskPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TASK);
};

export const isAppMasterTaskPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_MASTER_TASK);
};

export const isAppPurchasingPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_PURCHASING);
};

export const isAppTechnicalOfficePrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TECHNICAL_OFFICE);
};

export const isAppQualityPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_QUALITY);
};

export const isAppProductionPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_PRODUCTION);
};

export const isAppReadinessPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_READINESS);
};

export const isAppSimulatePrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_SIMULATE);
};

export const isAppToolAdminPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_TOOL);
};

export const isAppCNCPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_CNC);
};

export const isAppCheckMachinePrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_CHECK_MACHINE);
};

export const isAppCheckOperatorPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_CHECK_OPERATOR);
};

export const isAppSigningValidationPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_SIGNING_VALIDATION);
};

export const isAppCheckToolPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_CHECK_TOOL);
};

export const isAdminControlPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_CONTROL);
};

export const isAdminMachinePrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_MACHINE);
};

export const isAdminMachineGroupPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_MACHINE_GROUP);
};

export const isAdminToolPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_TOOL);
};

export const isAdminRefrigerationPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_REFRIGRETAION);
};

export const isAdminUsersPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_USERS);
};

export const isAdminCalendarPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_CALENDAR);
};

export const isAdminBOMPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_BOM);
};

export const isAdminCAMPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_CAM);
};

export const isAdminOFPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_OF);
};

export const isAdminBIPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_BI);
};

export const isAdminPresettingPrivilege = () => {
  return hasPrivilege(PRIVILEGE_ADMIN_PRESETTING);
};

export const isAppVisualizatorPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_VISUALIZATOR);
};

export const isAppMaintenancePrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_MAINTENANCE);
};

export const isAppToolManagementToolPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TM_TOOL);
};

export const isAppToolManagementOrderRequestPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TM_ORDER_REQUEST);
};

export const isAppToolManagementPendingOrdersPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TM_PENDING_ORDERS);
};

export const isAppToolManagementValidateReconstructionPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TM_VALIDATE_RECONSTRUCTION);
};

export const isAppToolManagementSendErpPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TM_SEND_ERP);
};

export const isAppToolManagementHistoricalPrivilege = () => {
  return hasPrivilege(PRIVILEGE_APP_TM_HISTORICAL);
};

export const canAccessAdministrator = () => {
  return isSAPrivilege() ||
    isAdminUsersPrivilege() ||
    isAdminBIPrivilege() ||
    isAdminBOMPrivilege() ||
    isAdminCAMPrivilege() ||
    isAdminCalendarPrivilege() ||
    isAdminControlPrivilege() ||
    isAdminMachinePrivilege() ||
    isAdminMachineGroupPrivilege() ||
    isAdminOFPrivilege() ||
    isAdminRefrigerationPrivilege() ||
    isAdminToolPrivilege() ||
    isAdminPresettingPrivilege() ||
    isAppMaintenancePrivilege();
};

export const canAccessGraphicMenus = () => {
  return isAppBI();
};

export const canAccessScheduler = () => {
  return isAppTaskPrivilege() ||
    isAppMasterTaskPrivilege();
};




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/jwt.utils.ts